var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 26.0002V34.0002C10.5 35.1047 11.3954 36.0002 12.5 36.0002H34.5C35.6046 36.0002 36.5 35.1047 36.5 34.0002V26.0002H38.5V34.0002C38.5 36.2093 36.7091 38.0002 34.5 38.0002H12.5C10.2909 38.0002 8.5 36.2093 8.5 34.0002V26.0002H10.5ZM22.5 13.4144L18.2071 17.7073C17.8166 18.0978 17.1834 18.0978 16.7929 17.7073C16.4024 17.3167 16.4024 16.6836 16.7929 16.293L23.5 9.58594L30.2071 16.293C30.5976 16.6836 30.5976 17.3167 30.2071 17.7073C29.8166 18.0978 29.1834 18.0978 28.7929 17.7073L24.5 13.4144V32.0002H22.5V13.4144Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.43744325365bfd65df8d2b67569886e8.svg";
export { ForwardRef as ReactComponent };